<div class="right-margin">
    <button class="close-icon" (click)="dialogRef.close(false)"><div class="line1"><div class="line2"></div></div></button>
</div>
<div class="body form">
    <h2>Client Selection</h2>
    <div class="mt-10 mb-10">
        <div><button type="button" class="loginBtnsBorder" style="width: 100%; height: 32px; min-height: 32px; padding: 0; font-size: 16px" (click)="addClient()">Add Client</button></div>
        <div class="checkbox-selector mt-10">
            <label [class.checked]="showResidential()">
                <input type="checkbox" name="showResidential" [checked]="showResidential()" (change)="toggleResidential($event)" />Residential
            </label>
            <label [class.checked]="showCommercial()">
                <input type="checkbox" name="showCommercial" [checked]="showCommercial()" (change)="toggleCommercial($event)" />Commercial
            </label>
        </div>
        <input type="text" autocomplete="off" name="search" [value]="query()" (input)="onQueryInput($event)" class="search" placeholder="Filter By Name" (focus)="searchFocus()" (focusout)="searchFocusOut()" (keydown)="searchSiteByKey($event)" />
        <ul [class]="getSearchAutocompleteClass()">
            @for (searchItem of searchAutocompleteItems(); track searchItem; let i = $index) {
            <li [class]="getAutocompleteClassItem(i)"><a (click)="changeClient(searchItem)">{{searchItem.clientName}} ({{searchItem.numberAccounts}})</a></li>
            }
        </ul>
    </div>
</div>